<nav data-test-id="vertical-menu" [class.collapsed]="isCollapsed" [attr.aria-labelledby]="uniqueId + '-title'">
  <div class="menu-title" [class.ds-visually-hidden]="isCollapsed">
    <h3 id="{{ uniqueId + '-title' }}">{{ menuTitle }}</h3>
    <hr role="presentation" />
  </div>

  <ul class="items-wrapper">
    @for (menuItem of menuItems; track $index) {
      @if (menuItem.children?.length) {
        <li
          class="submenu-container"
          (focusin)="handleSubMenuFocusin(menuItem)"
          (focusout)="handleSubMenuFocusout($event, menuItem)"
          (mouseenter)="handleSubMenuMouseenter(menuItem)"
          (mouseleave)="handleSubMenuMouseleave(menuItem)"
        >
          <button
            #submenuButton
            class="menu-item"
            [id]="menuItem.id + '-button'"
            [class.active]="isMenuItemActive(menuItem)"
            [class.expanded]="isSubmenuExpanded(menuItem.id)"
            [attr.aria-label]="getAriaLabelKey(menuItem) | translate"
            [attr.aria-expanded]="isSubmenuExpanded(menuItem.id)"
            [attr.aria-controls]="menuItem.id + '-submenu'"
            [attr.data-item-id]="menuItem.id"
            (click)="toggleExpandedStateSubmenu(menuItem.id)"
          >
            <ng-container *ngTemplateOutlet="itemContentTemplate; context: { menuItem: menuItem }"></ng-container>
            @if (!isCollapsed) {
              <span class="icon-holder">
                <ds-icon
                  class="expand-icon"
                  [iconStyle]="IconStyles.Light"
                  [icon]="isSubmenuExpanded(menuItem.id) ? Icons.ChevronUp : Icons.ChevronDown"
                ></ds-icon>
              </span>
            }
          </button>
          <div
            #submenuPanel
            role="region"
            class="submenu-panel"
            [id]="menuItem.id + '-submenu'"
            [class.expanded]="isSubmenuExpanded(menuItem.id)"
            [attr.aria-labelledby]="menuItem.id + '-button'"
            [attr.data-test-id]="isSubmenuExpanded(menuItem.id) ? 'submenu-panel-expanded' : 'submenu-panel-collapsed'"
          >
            @if (isCollapsed) {
              <div class="submenu-title">{{ menuItem.label | translate }}</div>
            }
            <ul>
              @for (subMenuItem of menuItem.children; track $index) {
                <li>
                  <ng-container
                    *ngTemplateOutlet="menuItemTemplate; context: { menuItem: subMenuItem, isSubMenu: true }"
                  ></ng-container>
                </li>
              }
            </ul>
          </div>
        </li>
      } @else {
        <li>
          <ng-container *ngTemplateOutlet="menuItemTemplate; context: { menuItem: menuItem }"></ng-container>
        </li>
      }
    }
  </ul>
</nav>

<ng-template #menuItemTemplate let-menuItem="menuItem" let-isSubMenu="isSubMenu">
  @if (isCollapsed && !isSubMenu) {
    @if (menuItem.externalLink) {
      <a
        class="menu-item"
        [ds-tooltip]="menuItem.label | translate"
        [tooltipPlacement]="DsTooltipPosition.right"
        [attr.aria-label]="getAriaLabelKey(menuItem) | translate"
        [attr.data-item-id]="menuItem.id"
        [href]="menuItem.externalLink"
        target="_blank"
        (click)="onMenuItemClick(menuItem)"
      >
        <ng-container
          *ngTemplateOutlet="itemContentTemplate; context: { menuItem: menuItem, isSubMenu: isSubMenu }"
        ></ng-container>
      </a>
    } @else if (menuItem.routerLink) {
      <a
        class="menu-item"
        [ds-tooltip]="menuItem.label | translate"
        [tooltipPlacement]="DsTooltipPosition.right"
        [attr.aria-label]="getAriaLabelKey(menuItem) | translate"
        [attr.aria-current]="isMenuItemActive(menuItem) ? 'page' : undefined"
        [attr.data-item-id]="menuItem.id"
        [routerLink]="menuItem.routerLink"
        [class.active]="isMenuItemActive(menuItem)"
        (click)="onMenuItemClick(menuItem)"
      >
        <ng-container
          *ngTemplateOutlet="itemContentTemplate; context: { menuItem: menuItem, isSubMenu: isSubMenu }"
        ></ng-container>
      </a>
    } @else {
      <button
        type="button"
        class="menu-item"
        [ds-tooltip]="menuItem.label | translate"
        [tooltipPlacement]="DsTooltipPosition.right"
        [attr.aria-label]="getAriaLabelKey(menuItem) | translate"
        [attr.aria-current]="isMenuItemActive(menuItem) ? 'page' : undefined"
        [attr.data-item-id]="menuItem.id"
        [class.active]="isMenuItemActive(menuItem)"
        (click)="onMenuItemClick(menuItem)"
      >
        <ng-container
          *ngTemplateOutlet="itemContentTemplate; context: { menuItem: menuItem, isSubMenu: isSubMenu }"
        ></ng-container>
      </button>
    }
  } @else {
    @if (menuItem.externalLink) {
      <a
        [href]="menuItem.externalLink"
        class="menu-item"
        [attr.aria-label]="menuItem.ariaLabel ? (menuItem.ariaLabel | translate) : null"
        [attr.data-item-id]="menuItem.id"
        target="_blank"
        (click)="onMenuItemClick(menuItem)"
      >
        <ng-container
          *ngTemplateOutlet="itemContentTemplate; context: { menuItem: menuItem, isSubMenu: isSubMenu }"
        ></ng-container>
      </a>
    } @else if (menuItem.routerLink) {
      <a
        class="menu-item"
        [class.active]="isMenuItemActive(menuItem)"
        [attr.aria-label]="menuItem.ariaLabel ? (menuItem.ariaLabel | translate) : null"
        [attr.aria-current]="isMenuItemActive(menuItem) ? 'page' : undefined"
        [attr.data-item-id]="menuItem.id"
        [routerLink]="menuItem.routerLink"
        (click)="onMenuItemClick(menuItem)"
      >
        <ng-container
          *ngTemplateOutlet="itemContentTemplate; context: { menuItem: menuItem, isSubMenu: isSubMenu }"
        ></ng-container>
      </a>
    } @else {
      <button
        type="button"
        class="menu-item"
        [class.active]="isMenuItemActive(menuItem)"
        [attr.aria-label]="menuItem.ariaLabel ? (menuItem.ariaLabel | translate) : null"
        [attr.aria-current]="isMenuItemActive(menuItem) ? 'page' : undefined"
        [attr.data-item-id]="menuItem.id"
        (click)="onMenuItemClick(menuItem)"
      >
        <ng-container
          *ngTemplateOutlet="itemContentTemplate; context: { menuItem: menuItem, isSubMenu: isSubMenu }"
        ></ng-container>
      </button>
    }
  }
</ng-template>

<ng-template #menuIconTemplate let-menuItem="menuItem">
  <ds-icon class="item-icon solid-icon" [iconStyle]="IconStyles.Solid" [icon]="menuItem.iconName ?? Icons.Folder"></ds-icon>
  <ds-icon class="item-icon light-icon" [iconStyle]="IconStyles.Light" [icon]="menuItem.iconName ?? Icons.Folder"></ds-icon>
</ng-template>

<ng-template #itemContentTemplate let-menuItem="menuItem" let-isSubMenu="isSubMenu">
  <span class="item-content">
    <span class="icon-holder">
      @if (!isSubMenu) {
        <ng-container *ngTemplateOutlet="menuIconTemplate; context: { menuItem: menuItem }"></ng-container>
      }
    </span>
    @if (!isCollapsed || isSubMenu) {
      <span class="menu-label">{{ menuItem.label | translate }}</span>
    }
  </span>
  @if (menuItem.external || menuItem.externalLink) {
    <ds-icon
      [icon]="Icons.ArrowUpRightFromSquare"
      [attr.aria-label]="'opens_in_new_tab_label' | translate"
      class="external-icon"
    ></ds-icon>
  }
</ng-template>
